import React from "react";
import { Routes, Route  } from "react-router-dom";
import NotFound from "../components/not-found";
import Home from "../components/home"; 
import Footer from "../components/footer/footer";
import Products from "./products/products";
import About from "./about/about";
import Faq from "./faq/faq";
import Shop from "./shop/shop";
import ContactUs from "./contact/contact-us";
import Search from "./search/search";
import Login from "./login/login";

const Public = () => { 

  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={ <Home /> }></Route>
        <Route  path="" element={<Home/>}></Route>
        <Route path="/products//*"  element={<Products/>} ></Route>
        <Route path="/about" element={<About/>}></Route>
        <Route path="/faq" element={<Faq/>}></Route>
        <Route path="/shop" element={<Shop/>}></Route>
        <Route path="/contact-us" element={<ContactUs/>}></Route>
        <Route path="/search//*" element={<Search/>}></Route>
        <Route path="/login/*" element={<Login/>}></Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
     <Footer />
    </React.Fragment>
  );
};

export default Public;
